import { fetchClient } from "../generated/client";

export async function generatePaymentMethodAdditionLinkQuery({
	shopId,
}: {
	shopId: string;
}): Promise<{ url: string }> {
	const response = await fetchClient.GET("/shops/{shopId}/billings", {
		params: { path: { shopId } },
	});

	return {
		url: response.data,
	} as { url: string };
}
